export const APP_VERSION_HEADER = {
  'X-Frontend-Version': process.env.REACT_APP_VERSION || '0.0.0',
};
